
import "./style.css"
import logo from 'assets/images/logo2.png'
export default function Home() {
    return (
        <div className='rootHome'>
            <div className='homeContent'>
                <div className='homeContentCenter'>
                    <img className='logoHome' src={logo} alt="Logo" />
                </div >
                <p>Com grande experiência no setor sucroenergético, José Trevelin Jr iniciou a TCH Gestão Agrícola, com um trabalho de consultoria para usinas do Mato Grosso do Sul, tendo como meta oferecer suporte aos produtores do setor, a fim de ampliar a competitividade destas companhias.</p>
                <p>Atualmente, conta com uma equipe capacitada em campo e planejamento, que permite entregar aos seus parceiros informações da gestão de cada área agrícola monitorada, com tecnologia, agilidade e acompanhamento integral.</p>
                <p>Com parceria com a BioSul – Associação dos Produtores de Bioenergia de Mato Grosso do Sul, a TCH soma esforços para colocar as usinas da região em destaque no mercado de agronegócio de cana-de-açúcar nacional, que somam mais de 613 mil hectares em área plantada com cana-de-açúcar.</p>
            </div>
        </div>
    )
}
